var map = {
	"./action.svg": 206,
	"./adventure.svg": 207,
	"./advertorial.svg": 208,
	"./ai.svg": 209,
	"./album.svg": 210,
	"./analysis.svg": 211,
	"./anchor.svg": 212,
	"./android-block.svg": 213,
	"./android-small.svg": 214,
	"./android.svg": 215,
	"./angle-down.svg": 216,
	"./angle-left.svg": 217,
	"./angle-right.svg": 218,
	"./angle-up.svg": 219,
	"./aquarius.svg": 220,
	"./arcade.svg": 221,
	"./aries.svg": 222,
	"./arrow-down.svg": 223,
	"./arrow-left.svg": 224,
	"./arrow-right.svg": 225,
	"./arrow-up.svg": 226,
	"./arrow.svg": 227,
	"./art-director.svg": 228,
	"./astrology.svg": 229,
	"./author-avator.svg": 230,
	"./author.svg": 231,
	"./authoranchor.svg": 232,
	"./authorwhite.svg": 233,
	"./automobile.svg": 234,
	"./backward.svg": 235,
	"./bookmark.svg": 236,
	"./books-vikatan.svg": 237,
	"./brandconnect.svg": 238,
	"./breaking-news.svg": 239,
	"./bullet-arrow.svg": 240,
	"./bundle.svg": 241,
	"./business.svg": 242,
	"./calendar.svg": 243,
	"./cancel.svg": 244,
	"./cancer.svg": 245,
	"./canvas.svg": 246,
	"./capricorn.svg": 247,
	"./cartoonist.svg": 248,
	"./cinema.svg": 249,
	"./clapboard.svg": 250,
	"./clipboard.svg": 251,
	"./close.svg": 252,
	"./comment.svg": 253,
	"./corona-updates-icon.svg": 254,
	"./creative-director.svg": 255,
	"./cricket.svg": 256,
	"./crime.svg": 257,
	"./data.svg": 258,
	"./designed.svg": 259,
	"./double-arrow.svg": 260,
	"./downarrow.svg": 261,
	"./download.svg": 262,
	"./edit.svg": 263,
	"./edited-by.svg": 264,
	"./email.svg": 265,
	"./environment.svg": 266,
	"./exclusivedeals.svg": 267,
	"./facebook-bg.svg": 268,
	"./facebook-icon.svg": 269,
	"./facebook.svg": 270,
	"./filter-icon.svg": 271,
	"./filter.svg": 272,
	"./food-stylist.svg": 273,
	"./forward.svg": 274,
	"./gallery.svg": 275,
	"./game-shop.svg": 276,
	"./gemini.svg": 277,
	"./group.svg": 278,
	"./gzhome.svg": 279,
	"./gzsports.svg": 280,
	"./gztrending.svg": 281,
	"./health.svg": 282,
	"./hexbackground.svg": 283,
	"./home.svg": 284,
	"./humoursatire-entertainment.svg": 285,
	"./icon-apple.svg": 286,
	"./icon-appstore.svg": 287,
	"./icon-audio-app-store.svg": 288,
	"./icon-audio-fb.svg": 289,
	"./icon-audio-instagram.svg": 290,
	"./icon-audio-next.svg": 291,
	"./icon-audio-play-store.svg": 292,
	"./icon-audio-previous.svg": 293,
	"./icon-audio-twitter.svg": 294,
	"./icon-audio-whatsapp.svg": 295,
	"./icon-copy.svg": 296,
	"./icon-episode.svg": 297,
	"./icon-facebook.svg": 298,
	"./icon-google-play.svg": 299,
	"./icon-headset.svg": 300,
	"./icon-home-plus.svg": 301,
	"./icon-login.svg": 302,
	"./icon-open-in-new.svg": 303,
	"./icon-pause.svg": 304,
	"./icon-play.svg": 305,
	"./icon-playstore.svg": 306,
	"./icon-premium.svg": 307,
	"./icon-share.svg": 308,
	"./icon-star.svg": 309,
	"./icon-timer.svg": 310,
	"./icon-twitter.svg": 311,
	"./icon-user.svg": 312,
	"./icon-video.svg": 313,
	"./icon-whatsapp.svg": 314,
	"./illustrator-t1.svg": 315,
	"./illustrator.svg": 316,
	"./infographer.svg": 317,
	"./instagram.svg": 318,
	"./interviews.svg": 319,
	"./ios-block.svg": 320,
	"./ios-small.svg": 321,
	"./ios.svg": 322,
	"./jokes.svg": 323,
	"./leo.svg": 324,
	"./libra.svg": 325,
	"./lifestyle.svg": 326,
	"./line-arrow-next.svg": 327,
	"./line-arrow-prev.svg": 328,
	"./linkedin.svg": 329,
	"./listicle.svg": 330,
	"./live-chat.svg": 331,
	"./liveupdate.svg": 332,
	"./log green.svg": 333,
	"./log grey.svg": 334,
	"./log white.svg": 335,
	"./logic.svg": 336,
	"./login-facebook.svg": 337,
	"./login-google.svg": 338,
	"./login.svg": 339,
	"./logout-mobile.svg": 340,
	"./logout.svg": 341,
	"./longform.svg": 342,
	"./magazines.svg": 343,
	"./mail.svg": 344,
	"./menu-search.svg": 345,
	"./microphone.svg": 346,
	"./minus.svg": 347,
	"./mobile-share.svg": 348,
	"./moderated.svg": 349,
	"./more-outline.svg": 350,
	"./my-vikatan-logo.svg": 351,
	"./mynews.svg": 352,
	"./myvikatanbadge.svg": 353,
	"./narrated.svg": 354,
	"./news.svg": 355,
	"./newsletter.svg": 356,
	"./newslettericon.svg": 357,
	"./olympic.svg": 358,
	"./online-news.svg": 359,
	"./pause.svg": 360,
	"./pdf.svg": 361,
	"./pen.svg": 362,
	"./personalise.svg": 363,
	"./phone.svg": 364,
	"./photo.svg": 365,
	"./photographer.svg": 366,
	"./photostory.svg": 367,
	"./pisces.svg": 368,
	"./play.svg": 369,
	"./plus.svg": 370,
	"./podcast.svg": 371,
	"./podcast_vikatan_menu.svg": 372,
	"./poems.svg": 373,
	"./politics.svg": 374,
	"./premium.svg": 375,
	"./producer.svg": 376,
	"./proofread.svg": 377,
	"./published-by.svg": 378,
	"./published.svg": 379,
	"./rain.svg": 380,
	"./rss.svg": 381,
	"./rupee.svg": 382,
	"./sagitarius.svg": 383,
	"./scorpio.svg": 384,
	"./script-writer.svg": 385,
	"./scripted.svg": 386,
	"./search.svg": 387,
	"./share-alt.svg": 388,
	"./share.svg": 389,
	"./sharechat.svg": 390,
	"./shortform.svg": 391,
	"./shortstories.svg": 392,
	"./shortvideo.svg": 393,
	"./slider-next.svg": 394,
	"./slider-prev.svg": 395,
	"./socialshare.svg": 396,
	"./sort.svg": 397,
	"./sound.svg": 398,
	"./speaker.svg": 399,
	"./speakeraudio.svg": 400,
	"./spiritual.svg": 401,
	"./sponsored.svg": 402,
	"./sports.svg": 403,
	"./star.svg": 404,
	"./stories.svg": 405,
	"./strategy.svg": 406,
	"./stylist.svg": 407,
	"./subscribe-vikatan.svg": 408,
	"./success-icon.svg": 409,
	"./tag.svg": 410,
	"./taurus.svg": 411,
	"./technology.svg": 412,
	"./text.svg": 413,
	"./textsms.svg": 414,
	"./thodargal.svg": 415,
	"./thump.svg": 416,
	"./tick.svg": 417,
	"./trending.svg": 418,
	"./twitter-icon.svg": 419,
	"./twitter.svg": 420,
	"./uparrow.svg": 421,
	"./update-black.svg": 422,
	"./user-square.svg": 423,
	"./user.svg": 424,
	"./v-plus-logo.svg": 425,
	"./video-editor.svg": 426,
	"./video-icon.svg": 427,
	"./video-play.svg": 428,
	"./video.svg": 429,
	"./videographer.svg": 430,
	"./vikatan-play-logo-red.svg": 431,
	"./vikatan-play.svg": 432,
	"./vikatan-tv.svg": 433,
	"./vikatan.svg": 434,
	"./vikatanconnect.svg": 435,
	"./vikatanplay.svg": 436,
	"./vikatanspl.svg": 437,
	"./vikatantv.svg": 438,
	"./virgo.svg": 439,
	"./whatsapp-icon.svg": 440,
	"./whatsapp-icon1.svg": 441,
	"./whatsapp.svg": 442,
	"./women-home.svg": 443,
	"./writtenarticles.svg": 444,
	"./writtenstory.svg": 445,
	"./youtube.svg": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;